import styled from 'styled-components';
import * as awsui from '@amzn/awsui-design-tokens';

const Banner = styled.div`
    position: fixed;
    top: 0px;
    right: 0;
    width: 100%;
    z-index: 3;
`;

const Divider = styled.div`
    height: 1px;
    border-bottom: 1px solid ${awsui.colorBorderDividerDefault};
    width: 100%;
`;

const EmptyReviewDetails = styled.div`
    background-color: ${awsui.colorBackgroundContainerContent};
    border: 1px solid ${awsui.colorBorderDividerDefault};
    border-radius: 5px;
    min-height: 350px;
    padding: 20px;
`;

const EvaluationContentBox = styled.div`
    width: 33%;
    @media (max-width: 1000px) {
        width: 100%;
    }

`;

const EvaluationGuidelines = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    border: 1px solid ${awsui.colorBorderDividerDefault};
    border-radius: 5px;
    padding: 15px;
`;

const EvaluationGuidelinesHeader = styled.div`
    font-size: 1.5rem;
    font-weight: 600;
    width: 100%;
    text-align: center;
    padding-bottom: 12px;
    margin-bottom: 8px;
    border-bottom: 1px solid ${awsui.colorBorderDividerDefault};
`;

const InputValidationErrors = styled.div`
`;

const FormBody = styled.div`
    position: relative;
`;

const FormDetails = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: stretch;

    .review-details {
        display: flex;
        flex: 1 1 auto;
        flex-wrap: wrap;
        overflow: auto;
    }
`;

const FormCheckboxField = styled.div`
    flex: 1 1 auto;
    margin: 5px 0px;
`;

const SidePanelWrapper = styled.div`
    position: sticky;
    display: flex;
    flex-direction: column;
    gap:8px;
    top: 10px;
`;

const Submit = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-top: 10px;
`;
const PanelText = styled.p``;

const RseReminder = styled.div`
    margin: 15px 0px;
    text-align: center;
`;

const QualityQuestionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid ${awsui.colorBorderDividerDefault};
    gap: 8px;
`;

const QualityQuestionLabel = styled.div`
    display: flex;
    font-weight: 600;

    p {
        margin-bottom: 0;
    }
`;

const QualityQuestionAnswer = styled.div`
    max-width: 200px;
`;

const BiQuestionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-bottom: 12px;
    border-bottom: 1px solid ${awsui.colorBorderDividerDefault};
    gap: 8px;
`;

const BiQuestionLabel = styled.div`
    display: flex;
    font-weight: 600;

    p {
        margin-bottom: 0;
    }
`;

const BiQuestionAnswer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
`;

const QualitySubAttributeWrapper = styled.div`
    width: 100%;
`;

export default {
    Banner,
    BiQuestionWrapper,
    BiQuestionLabel,
    BiQuestionAnswer,
    Divider,
    EmptyReviewDetails,
    EvaluationContentBox,
    EvaluationGuidelines,
    EvaluationGuidelinesHeader,
    FormBody,
    FormDetails,
    FormCheckboxField,
    InputValidationErrors,
    SidePanelWrapper,
    Submit,
    PanelText,
    RseReminder,
    QualityQuestionWrapper,
    QualityQuestionLabel,
    QualityQuestionAnswer,
    QualitySubAttributeWrapper
};
